import getImageById from '@/components/ImageSelector/getImageById';
import axios from 'axios';

const ReportFieldBoilerplate = {
    props: {
        field: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            submission: '',
            imageSource: undefined,
            fileName: undefined,
            fileId: undefined,
            fileExtension: undefined,
        };
    },

    mounted() {
        if (this.field.submission[0] && this.field.submission[0].submission) {
            this.submission = this.field.submission[0].submission;
        } else if (this.field.population[0] && this.field.population[0].population) {
            this.submission = this.field.population[0].population;
        }
    },

    methods: {
        getImageData() {
            let image = undefined;

            if (this.submission) {
                if (this.submission.selectedImage) {
                    image = this.submission.selectedImage;
                }

                else if (this.submission.data && this.submission.data.template) {
                    image = this.submission.data.template;
                }
            }

            if (image) {
                getImageById(image)
                    .then((response) => {
                        this.fileId = response.id;
                        this.fileExtension = response.extension;

                        if (response.extension === 'pdf') {
                            this.imageSource = this.$storageURL + 'placeholder/pdf-placeholder.jpg';
                            this.fileName = response.filename + '.' + response.extension;
                        } else {
                            this.imageSource = this.$storageURL + response.directory + '/' + response.filename + '.' + response.extension;
                            this.fileName = response.filename + '.' + response.extension;
                        }
                    });
            }
        },

        download() {
            let contentType = '';

            if (this.fileExtension === 'pdf') {
                contentType = 'application/pdf';
            }

            if (this.fileExtension === 'png') {
                contentType = 'image/png';
            }

            if (this.fileExtension === 'jpg' || this.fileExtension === 'jpeg') {
                contentType = 'application/jpeg';
            }

            axios.get('/api/media/download/'+ this.fileId, {responseType: 'arraybuffer'})
                .then(response => {
                    let blob = new Blob([response.data], { type: contentType });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.fileName;
                    link.click();
                    link.remove();
                });
        },

        format(code) {
            const toFormat = code;
            let beautify_html = require('js-beautify').html;
            return beautify_html(toFormat, {
                indent_size: 2,
                indent_char: ' ',
                indent_body_inner_html: true,
            }).trim();
        },

        elementorKeySuffix(field) {
            return field;
        }
    }
};

export default ReportFieldBoilerplate;
